import { render, staticRenderFns } from "./UnregisteredNotificationsGridModal.vue?vue&type=template&id=4278e744&scoped=true"
import script from "./UnregisteredNotificationsGridModal.vue?vue&type=script&lang=js"
export * from "./UnregisteredNotificationsGridModal.vue?vue&type=script&lang=js"
import style0 from "./UnregisteredNotificationsGridModal.vue?vue&type=style&index=0&id=4278e744&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4278e744",
  null
  
)

export default component.exports